import { IMetadata } from './metadata/Metadata';
import { IOutput } from './output/Output';
import { IWidget } from './widget/Widget';
import { IProcedureAttachment } from './ProcedureAttachment';
import { IPrintItem } from './print-item/PrintItem';
import { IPrintOptions } from './print-options/PrintOptions';
import { IUser } from './User';
import { IScoringRule } from './scoring/ScoringRule';
import { IProcedureDocument } from './ProcedureDocument';
import { IProcedureEnabledUser } from './ProcedureEnabledUser';

export interface IProcedure {
  id: number;
  title?: string;
  code?: string | null;
  hideTitleInDetailPage: boolean;
  description: string;
  laws?: string;
  categories: string[];
  state: ProcedureState;

  attachments?: IProcedureAttachment[];

  commission?: IUser[];
  consultants?: IUser[];

  responsabilityOfficeId?: number | null;
  responsabilityOfficeCode?: string | null;

  dossierType?: ProcedureDossierType;
  dossierNumber?: number | null;
  dossierTypologyId?: number | null;
  dossierTypologyCode?: string | null;

  documentType: ProcedureDocumentType;
  documentTypologyId?: number | null;
  documentTypologyCode?: string | null;

  registerOfficeId?: number | null;
  registerOfficeCode?: string | null;
  administrationCode?: string | null;

  recipient: ProcedureRecipient;
  requiresAuth: boolean;
  groupId?: number | null;
  isUnique: boolean;
  listHidden: boolean;
  compileButtonHidden: boolean;

  activeScoring: boolean;
  activeEnabledUsers: boolean;

  isCurrentUserEnabled?: boolean;

  pointAssignmentType?: PointAssignmentType | null;
  disjointPointMethod?: DisjointPointMethod | null;
  meanRoundingMethod?: MeanRoundingMethod | null;

  rankingFields?: IRankingField[] | null;

  publishedAt?: Date | null;
  activatedAt?: Date | null;
  expiresAt?: Date | null;
  evaluatedAt?: Date | null;
  createdAt: Date;
  updatedAt: Date;
  metadata: IMetadata[];
  outputs: IOutput[];
  widgets: IWidget[];
  documents: IProcedureDocument[];
  printOptions: IPrintOptions;
  scoringRules: IScoringRule[];

  acl: number | null;
  categoryIndex: number | null;
}

export enum ProcedureState {
  Draft = 'Draft',
  Ready = 'Ready',
  Published = 'Published',
  Active = 'Active',
  Evaluating = 'Evaluating',
  Expired = 'Expired',
  Canceled = 'Canceled',
  Suspended = 'Suspended',
  Test = 'Test'
}

export enum ProcedureDossierType {
  None = 'None',
  One = 'One',
  Each = 'Each'
}

export enum ProcedureDocumentType {
  /** Documento Grigio (non protocollato) */
  Simple = 'Simple',
  /** Documento Protocollato */
  Registered = 'Registered',
  /** Documento Protocollato con tipologia documentale */
  Extended = 'Extended'
}

export interface ICategory {
  label: string;
}

export interface ICategoryResult {
  category: string;
}

export enum ProcedureRecipient {
  Citizen = 'Citizen',
  Company = 'Company',
  Employee = 'Employee'
}

export enum PointAssignmentType {
  Unified = 'unified',
  Disjoint = 'disjoint'
}

export enum DisjointPointMethod {
  Sum = 'sum',
  Mean = 'mean'
}

export enum MeanRoundingMethod {
  Ceil = 'ceil',
  Floor = 'floor',
  NearIngeger = 'nearInteger',
  OneDecimalDigit = 'oneDecimalDigit'
}

export interface IRankingField {
  id: string;
  label: string;
  order: number;
}
